.oab-screen {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.oab-screen > .oab-spinner {
  width: 32px;
  height: 32px;
}

oab-fe {
  width: 100%;
}